import "./WrapperComp.css";
import { defineComponent as d, resolveComponent as b, openBlock as s, createElementBlock as o, normalizeClass as p, createElementVNode as c, toDisplayString as i, renderSlot as l, createBlock as y, createCommentVNode as n } from "vue";
import { i as a } from "./isNil.6f60d6a4.js";
import { u as f } from "./uniqueId.f48d78c2.js";
import { IconComp as M } from "./IconComp.js";
import { _ as w } from "./_plugin-vue_export-helper.dad06003.js";
const _ = Object.freeze({
  APAC: "APAC",
  EMEA: "EMEA",
  AMER: "AMER"
}), A = [
  "DE305062987",
  "DE815834871",
  "GB180994667",
  "FR14799556774",
  "SE516411343201",
  "IT02450400037"
], C = /^[A-Z]{2}/, g = /^[a-zA-Z0-9]+$/, T = /^[0-9]+$/, h = /^[a-z0-9!#$%&'*+=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9]{2,}(?:[a-z0-9-]*[a-z0-9])?$/;
function v(e) {
  return !!e;
}
function E(e) {
  return e.indexOf(" ") === -1;
}
function F(e) {
  return /^(\{){0,1}[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}(\}){0,1}$/gi.test(e);
}
function $(e, r, t) {
  return !!e && !!r && !!t;
}
function S(e, r) {
  return a(e) ? !0 : e.length <= r;
}
function x(e, r) {
  return a(e) ? !0 : e.length >= r;
}
function I(e) {
  return a(e) || e === "" ? !0 : g.test(e);
}
function R(e, r) {
  return !A.includes(`${r}${e}`);
}
function z(e) {
  return C.test(e);
}
function B(e) {
  return h.test(e.toLowerCase());
}
function N(e) {
  return typeof e != "object" ? !0 : (e == null ? void 0 : e.value.region) !== _.APAC;
}
function O(e) {
  return typeof e != "object" ? !0 : (e == null ? void 0 : e.value.isRestricted) === !1;
}
function P(e, r) {
  return typeof e != "object" ? !0 : (e == null ? void 0 : e.value.region) === r;
}
function k(e) {
  if (a(e))
    return !0;
  const r = e.value.replace(".", "");
  return !isNaN(r) && !isNaN(parseFloat(r)) && r.length < 17;
}
function j(e, r) {
  return e === r;
}
function D(e, r) {
  return typeof e != "string" ? !1 : e.replace(/\s/g, "").length <= r;
}
function L(e) {
  return a(e) || e === "" ? !0 : g.test(e);
}
function q(e, r) {
  return r.toLocaleLowerCase() !== e.toLocaleLowerCase().substring(0, 2);
}
function G(e) {
  return T.test(e);
}
function W(e) {
  const r = (e || "").split(",").map((t) => t.trim()).filter((t) => !!t);
  return r.length > 0 && r.every((t) => h.test(t.toLowerCase()));
}
const Z = {
  required: v,
  requiredMany: $,
  max: S,
  min: x,
  alphaNumeric: I,
  nonProtolabsVatNumber: R,
  validVatId: z,
  email: B,
  apacOnlyCountry: N,
  restrictedCountry: O,
  differentRegion: P,
  validHarmonizedCommodityCode: k,
  confirmed: j,
  postalCodeMax: D,
  validEori: L,
  noCountryPrefixRepeat: q,
  noSpaces: E,
  validateGuid: F,
  numeric: G,
  commaDelimitedEmails: W
}, H = Z;
function V(e) {
  return e.map((r) => {
    if (r.validationFunction)
      return r;
    if (!r.validation)
      throw new Error("Validation prop needed if not providing your own validation function");
    const t = H[r == null ? void 0 : r.validation];
    return r.validationFunction = (u) => t(u, ...r.arguments || []), r;
  });
}
const J = d({
  props: {
    modelValue: Object,
    id: {
      type: String,
      required: !1,
      default: () => f("validationId")
    },
    validationRules: {
      type: Array,
      default: () => []
    },
    errorMessages: {
      type: Array,
      default: () => []
    },
    /**
     * Used for disabling error or info messages from being seen or validation from running
     */
    disableMessages: Boolean,
    /**
     * Used for determining when to run the validation rules on input
     */
    validateOn: {
      type: String,
      default: "blur"
    }
  },
  computed: {
    validationFunctionArray() {
      return V(this.validationRules);
    },
    filteredErrorMessages() {
      return this.errorMessages.filter((e) => e.id === this.id);
    },
    isErrorState() {
      var e;
      return ((e = this.filteredErrorMessages) == null ? void 0 : e.length) > 0;
    }
  },
  methods: {
    validateInputOnBlur() {
      if (!this.disableMessages && this.validateOn === "blur") {
        const e = this.runValidationMethod(this.modelValue);
        this.$emit("update:errorMessages", e);
      }
    },
    runValidationMethod(e) {
      const r = [...this.errorMessages.filter((t) => t.id !== this.id)];
      return this.validationFunctionArray.forEach((t) => {
        (t.validationFunction ? t.validationFunction(e) : null) || r.push({
          id: this.id,
          validation: t.validation,
          errorMessageText: t.errorMessageText
        });
      }), r;
    }
  }
}), K = d({
  mixins: [J],
  components: { IconComp: M },
  props: {
    id: {
      type: String,
      required: !1,
      default: () => f("wrapperComp")
    },
    validationRules: {
      type: Array,
      default: () => []
    },
    errorMessages: {
      type: Array,
      default: () => [],
      Note: 'This is the secondary v-model:errorMessages="" of the component'
    },
    infoMessages: {
      type: Array,
      default: () => []
    },
    label: String,
    supportingText: String,
    disableMessages: Boolean,
    disabled: Boolean,
    labelAbove: Boolean,
    hasPlaceholder: Boolean,
    isFocused: Boolean,
    filled: Boolean,
    labelSpecialText: String,
    labelIcon: String
  },
  computed: {
    wrapperClasses() {
      return {
        wrapper: !0,
        "wrapper--disabled": this.disabled
      };
    },
    headerClasses() {
      return {
        wrapper__header: !0,
        wrapper__labelAbove: this.labelAbove,
        wrapper__compactLabel: !this.labelAbove,
        "wrapper--hasPlaceholder": this.hasPlaceholder,
        "wrapper--isFocused": this.isFocused,
        "wrapper--filled": this.filled
      };
    },
    messagesClassObject() {
      return {
        wrapper__footer: !0,
        "wrapper__footer--error": this.showErrorMessages,
        "wrapper__footer--info": this.showInfoMessages && !this.showErrorMessages
      };
    },
    showInfoMessages() {
      return this.infoMessages.length > 0;
    },
    showErrorMessages() {
      return this.errorMessagesToDisplay.length > 0;
    },
    errorMessagesToDisplay() {
      return this.errorMessages.filter((e) => e.id === this.id);
    },
    messageText() {
      var e;
      return ((e = this.errorMessagesToDisplay[0]) == null ? void 0 : e.errorMessageText) || this.infoMessages[0];
    }
  }
});
const Q = ["for"], U = {
  key: 0,
  class: "wrapper__labelSpecialText"
}, X = {
  key: 0,
  class: "wrapper__supportingText"
}, Y = { class: "wrapper__footerText" };
function ee(e, r, t, u, re, te) {
  const m = b("icon-comp");
  return s(), o("div", {
    class: p(e.wrapperClasses)
  }, [
    e.label || e.supportingText ? (s(), o("div", {
      key: 0,
      class: p(e.headerClasses)
    }, [
      c("label", {
        for: e.id,
        class: "wrapper__labelText"
      }, [
        c("span", null, i(e.label), 1),
        l(e.$slots, "labelIcon", {}, () => [
          e.labelIcon ? (s(), y(m, {
            key: 0,
            icon: e.labelIcon,
            class: "wrapper__labelIcon"
          }, null, 8, ["icon"])) : n("", !0)
        ], !0),
        e.labelSpecialText ? (s(), o("span", U, i(e.labelSpecialText), 1)) : n("", !0)
      ], 8, Q),
      l(e.$slots, "supportingText", { supportingText: e.supportingText }, () => [
        e.labelAbove && e.supportingText ? (s(), o("p", X, i(e.supportingText), 1)) : n("", !0)
      ], !0)
    ], 2)) : n("", !0),
    l(e.$slots, "default", {}, void 0, !0),
    e.disableMessages ? n("", !0) : (s(), o("div", {
      key: 1,
      class: p(e.messagesClassObject)
    }, [
      l(e.$slots, "messages", { messageText: e.messageText }, () => [
        c("p", Y, i(e.messageText), 1)
      ], !0)
    ], 2))
  ], 2);
}
const ue = /* @__PURE__ */ w(K, [["render", ee], ["__scopeId", "data-v-6fe90479"]]);
export {
  J as V,
  ue as W
};
//# sourceMappingURL=WrapperComp.f674f2c9.js.map
